<template>
    <v-flex>
        <listing-item v-for="(item, index) in listings" :key="index">
            <template v-slot:item-icon>
                <div class="hex-container">
                    <div class="hex full-time"></div>
                    <svg style="visibility: hidden; position: absolute;" width="0" height="0"
                        xmlns="http://www.w3.org/2000/svg" version="1.1">
                        <defs>
                            <filter id="goo">
                                <feGaussianBlur in="SourceGraphic" stdDeviation="8" result="blur" />
                                <feColorMatrix in="blur" mode="matrix" values="1 0 0 0 0  0 1 0 0 0  0 0 1 0 0  0 0 0 19 -9"
                                    result="goo" />
                                <feComposite in="SourceGraphic" in2="goo" operator="atop" />
                            </filter>
                        </defs>
                    </svg>
                </div>
            </template>
            <template v-slot:item-details>
                <v-row>
                    <v-col md="5" cols="7" style="text-align: left;">
                        <h2>{{ item.label }}</h2>
                    </v-col>
                </v-row>
                <v-row dense>
                    <v-col md="7" cols="12">
                        <p>{{ item.description }}</p>
                    </v-col>
                </v-row>
            </template>
        </listing-item>
    </v-flex>
</template>

<style lang="scss" scoped>
@import '../../styles/styles.scss';
</style>

<script>
import ListingItem from '../../components/common/Contractor/ListingItem';

export default {
    name: 'contract-listings',
    components: {
        'listing-item': ListingItem
    },
    data: () => ({
        listings: [{ label: 'TEST', description: 'lore iadsflka kjafkdsfj ie ialsdk fjkdajlk sdhgalskhgaskldnf a;naslkfjkle kjas,' }]
    })
}
</script>
